import React from 'react';

const AboutPage = ({ onNavigateHome }) => {
    return (
        <section className="about-page">
            <div className="about-panel">
                <p className="about-kicker">Orientation File // Agathology + Ponerology</p>
                <h2 className="about-title">About The Discerner</h2>
                <div className="about-body">
                    <p className="about-intro">
                        In a distant corner of the world, a small group of Orthodox men met by providence. All aspired to be writers and felt that many topics, especially those related to culture, power, and belief, could no longer be discussed openly without risk. Writing anonymously offered a way to speak truthfully when silence was no longer an option. Gradually, more people joined, and The Discerner was born.
                    </p>
                    <p>
                        The Discerner began because the world ceased to make sense. Everywhere, stories, outrage cycles, and information from all sides bombard the mind in an overwhelming assault, often driven by entities with hidden agendas. There is little effort to pause, reflect, and truly understand the factors that influence individuals and society. It often feels like a war on meaning itself. This site explores agathology and ponerology from the perspective of Orthodox Christian laypeople, not influenced by politics, trends, online movements, or the desire to be another compromised voice. The aim is to think clearly, recognize patterns, and build genuine discernment rather than reacting emotionally to the loudest voices of the week.
                    </p>
                    <p>
                        Every contributor is an Orthodox Christian who actively practices their faith and participates in the Church’s sacramental life. We do not hold positions of authority and do not speak on behalf of the Church. As laypeople rooted in prayer and tradition, we honestly evaluate the world around us. This effort is not political, nor is it intended to generate fear. Instead, it aims to promote clarity, discernment, and research, encouraging individuals to decide what to believe rather than relying on those with the largest platforms.
                    </p>
                    <p>
                        Some subjects are challenging because history is often intentionally concealed, altered, or incomplete. When we include speculation, it is clearly indicated in our grading system for each article. We distinguish between verified facts and inferences, allowing readers to form their own opinions rather than adding to the era's confusion. Much of our content explores media, power, culture, symbolism, belief systems, and historical patterns, along with reflections on saints, sacred history, prayer, and the lived experiences of the Church, or simply the topics we feel most compelled to share.
                    </p>
                    <blockquote className="about-quote">
                        <p>
                            “Be not conformed to this world, but be transformed by the renewing of your mind.”
                        </p>
                        <cite>— Romans 12:2</cite>
                    </blockquote>
                </div>
                {/* <div className="about-body">
                    <p className="about-intro">
                        The Discerner examines agathology and ponerology——the study of Good and evil——through the lens of Orthodox Christianity rather than the shifting narratives of the age. Our purpose is to equip the faithful with the discernment needed to understand the cultural, spiritual, and ideological forces shaping our time.
                    </p>
                    <p>
                        This project began when, through God’s providence, a small group of men found themselves gathered in a humble church in parts unknown—men united by a resolve to proclaim Truth through the written word. From that quiet foundation arose an anonymous platform where clergy and laity may speak freely, without fear of professional or social consequence. In an era when honest analysis can carry real cost, this space allows concerns about moral corruption, cultural distortion, and spiritual deception to be brought into the light.
                    </p>
                    <p>
                        All contributors must be baptized Orthodox Christians who actively participate in the Church’s ecclesiastical life. This ensures that every article—whether cultural critique, historical inquiry, or spiritual reflection—remains rooted in prayer, humility, and fidelity to Holy Tradition.
                    </p>
                    <p>
                        Guided by the two-millennia-old phema of the Church, we seek to interpret the present age not through modern bias or ideological filter, but through the eternal Truth revealed by God. Our aim is not to spread propaganda, amplify fear, or serve hidden actors; rather, we strive to cultivate sober vigilance, clarity of mind, and the healing light of discernment.
                    </p>
                    <p>
                        Some subjects inevitably require speculation, for much of history and culture leaves no definitive record. These topics are approached with sobriety, marked clearly, and always distinguished from evidence. To maintain intellectual integrity, every article receives a Confidence Score indicating its level of grounding:
                    </p>
                    <ol className="about-confidence-list">
                        <li>Speculative</li>
                        <li>Emerging Narrative</li>
                        <li>Evidence-Based Claim</li>
                        <li>Mainstream Facts with Alternative Framing</li>
                        <li>Established Consensus or Ideology</li>
                    </ol>
                    <p>
                        This framework helps readers navigate a landscape where fact, pattern, and inference often intermingle.
                    </p>
                    <p>
                        Our work addresses themes such as cultural engineering, ideological subversion, symbolic messaging, story distortion, historical reframing, and the erosion of morality. At the same time, The Discerner turns toward what heals: Orthodox monasteries, saints, sacred history, pilgrimages, and places where grace has taken root.
                    </p>
                    <p>
                        Analysis strips away the world’s illusions; the Church illumines the soul. Both are needed, for the adversary still prowls like a roaring lion, seeking whom he may devour.
                    </p>
                    <blockquote className="about-quote">
                        <p>
                            “And be not conformed to this world: but be ye transformed by the renewing of your mind,
                            that ye may prove what is that good, and acceptable, and perfect, will of God.”
                        </p>
                        <cite>— Romans 12:2</cite>
                    </blockquote>
                </div> */}
                {/* <div className="about-meta">
                    <span className="about-meta__item">FOCUS: Agathology &amp; Ponerology through the Orthodox Church</span>
                    <span className="about-meta__item">CONTRIBUTORS: Baptized, active Orthodox Christians</span>
                    <span className="about-meta__item">METHOD: Confidence Scores, sober sourcing, prayerful tone</span>
                </div> */}
            </div>

            <div className="about-grid">
                {/* <div className="about-card">
                    <h3>What We Publish</h3>
                    <p>
                        Each document is a snapshot from the field. Some are polished theses; others are rough probes meant to
                        be stress-tested in public. Typical signals:
                    </p>
                    <ul className="about-list">
                        <li>Longform essays tracing how “the good” gets distorted or restored in everyday life.</li>
                        <li>Case files on institutions, relationships, and rituals that shape conscience.</li>
                        <li>Reading notes that translate academic work into plain speech and practical experiments.</li>
                    </ul>
                </div>

                <div className="about-card">
                    <h3>How To Read</h3>
                    <p>
                        This blog resists hot takes. Posts are dated, sourced where possible, and marked with a confidence signal.
                        Readers are invited to interrogate the assumptions, note where evidence is thin, and suggest better frames.
                    </p>
                    <ul className="about-list">
                        <li>Field notes (comments) are open to lay readers; cite sources when you can.</li>
                        <li>Disagreement is welcome; bad-faith brawls are not.</li>
                        <li>If something feels off, request a revision rather than a fight.</li>
                    </ul>
                </div> */}

                <div className="about-card">
                    <h3>Contribute Or Collaborate</h3>
                    <p>
                        Writers use a passphrase-protected portal to submit drafts and maintain prior documents.
                        If you have an invite code, register in the portal; otherwise reach out to Admin@discerner.blog.
                    </p>
                    <ul className="about-list">
                        <li>Share field observations, original reporting, or annotated sources.</li>
                        <li>Flag ethical blind spots or gaps in the bibliography.</li>
                        <li>Propose series themes on virtue, vice, or the gray areas between.</li>
                    </ul>
                </div>
            </div>

            <div className="about-cta">
                <div>
                    <p className="about-cta__eyebrow">Ready to dive back in?</p>
                    <h4 className="about-cta__title">Return to the document index</h4>
                    <p className="about-cta__text">
                        Browse the latest dispatches, filter by tag, or open the writer portal if you have work to file.
                    </p>
                </div>
                <button
                    type="button"
                    className="back-button"
                    onClick={() => onNavigateHome?.()}
                >
                    Back to Home
                </button>
            </div>
        </section>
    );
};

export default AboutPage;
